import React from 'react'

import CompletedProgramsTable from '../../../components/v2/CompletedProgramsTable'
import DepartmentHeader from '../../../components/v2/DepartmentHeader'

export default function AssessmentViewPrograms(props) {
    return (
        <React.Fragment>
            <div className="text-center fs-2">
                Select a program to view
            </div>

            <div className="p-5 pb-md-4 mx-auto">
                <div className="p-1 text-center">
                    
                </div>

                <DepartmentHeader department={props.department} />

                {props.department
                    ? 
                      <CompletedProgramsTable 
                        submittedPrograms={props.department.submittedPrograms} 
                        programAssessments={props.programAssessments}
                        />
                    : <></>
                }
            </div>
        </React.Fragment>
    )
}